/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'headerIcons/goals': {
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    data: '<g _fill="#000" fill-rule="evenodd"><circle pid="0" cx="13" cy="13" r="5"/><path pid="1" d="M13 0c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0zm0 2C6.925 2 2 6.925 2 13s4.925 11 11 11 11-4.925 11-11S19.075 2 13 2z"/><path pid="2" d="M13 4a9 9 0 110 18 9 9 0 010-18zm0 2a7 7 0 100 14 7 7 0 000-14z"/></g>'
  }
})
